const actionType = {
    DISABLE_LOADER: 'DISABLE_LOADER',
    ENABLE_LOADER: 'ENABLE_LOADER',
};
export default actionType;
